// French strings of the « Studio » screens (web/ui/studio.js). Registered at module load; keys
// are prefixed "studio." so they never collide with the shell dictionary.
import { registerStrings } from '../../i18n/fr.js';

registerStrings({
  'studio.title': 'Studio',
  'studio.eyebrow': 'STUDIO · {floor}',
  'studio.floorTitle': 'Studio de l’étage',
  'studio.deptTitle': 'Studio · {dept}',
  'studio.allDepts': 'Tous les services',
  'studio.deptLabel': 'Service',
  // An element of another floor (a parent or a child of this floor's)
  'studio.deptOnFloor': '{dept} · {floor}',
  'studio.deptOnFloorTitle': 'Service « {dept} » de l’étage « {floor} »',
  'studio.kindsLabel': 'Types d’éléments',
  'studio.allStatuses': 'Tous',
  'studio.statusesLabel': 'Filtrer par statut',
  'studio.search': 'Rechercher un titre, une étiquette, une réf. (K7Q2)…',
  'studio.ref.title': 'Référence courte : donnez-la aux agents (« refais K7Q2 »)',
  'studio.ref.copy': 'Copier la référence (à donner aux agents : « refais K7Q2 »)',
  'studio.ref.copyLabel': 'Copier la référence {ref}',
  'studio.agent': 'Agent',
  'studio.allAgents': 'Tous les agents',
  'studio.tag': 'Étiquette',
  'studio.allTags': 'Toutes les étiquettes',
  'studio.sort': 'Trier',
  'studio.sort.recent': 'Plus récents',
  'studio.sort.old': 'Plus anciens',
  'studio.sort.status': 'Par statut',
  'studio.sort.title': 'Par titre',
  'studio.more': 'Afficher plus ({n} sur {total})',
  'studio.count': { one: '{n} élément', other: '{n} éléments' },
  'studio.empty.title': 'Rien ici pour l’instant',
  'studio.empty.text': 'Les éléments créés par les agents (ou par vous) apparaîtront ici en direct.',
  'studio.empty.filtered': 'Aucun élément ne correspond à ces filtres.',
  'studio.clearFilters': 'Effacer les filtres',
  'studio.none.title': 'Pas de studio sur cet étage',
  'studio.none.text': 'Un administrateur l’active pour tout l’étage dans Administration → Étages & services : chacun de ses services peut alors créer et suivre ses pubs ici.',
  'studio.none.admin': 'Étages & services',
  'studio.loadError': 'Chargement impossible',
  'studio.retry': 'Réessayer',
  'studio.live': 'En direct',
  'studio.updatedAgo': 'modifié {when}',
  'studio.noThumb': 'Pas encore de fichier',
  'studio.locked': 'Pris par une tâche',
  'studio.new': 'Nouveau',
  'studio.new.person': 'Nouvelle personne',
  'studio.new.title': 'Nouvel élément : {kind}',
  'studio.new.titlePerson': 'Nouvelle personne',
  'studio.new.name': 'Titre',
  'studio.new.namePerson': 'Nom',
  'studio.new.dept': 'Service',
  'studio.new.create': 'Créer',
  'studio.new.required': 'Indiquez un nom.',
  'studio.new.done': 'Élément créé : ajoutez ses informations et ses fichiers.',
  'studio.new.pub': 'Nouvelle pub',

  // « Nouvelle pub » (a studio on brief): the brief and its pub together
  'studio.newAd.title': 'Nouvelle pub',
  'studio.newAd.create': 'Créer la pub',
  'studio.newAd.ideaHint': 'Le concepteur écrit le script à partir de cette idée.',
  'studio.newAd.ideaRequired': 'Décrivez l’idée de la pub.',
  'studio.newAd.files': 'Fichiers de référence',
  'studio.newAd.filesHint': 'Photos ou vidéos (casting, produit) jointes au brief.',
  'studio.newAd.picked': { one: '1 fichier choisi', other: '{n} fichiers choisis' },
  'studio.newAd.done': 'Pub créée : le concepteur va écrire son script.',

  // « Ajouter des hooks » (the Hooks tab): many hook videos at once, one hook each
  'studio.hooks.add': 'Ajouter des hooks',
  'studio.hooks.title': 'Ajouter des hooks',
  'studio.hooks.drop': 'Déposez vos vidéos de hooks ici, ou cliquez pour les choisir.',
  'studio.hooks.dropHint': 'Une vidéo par hook (mp4, mov ou webm, 60 Mo au plus) : chacune devient un hook « Disponible ».',
  'studio.hooks.listLabel': 'Vidéos choisies',
  'studio.hooks.size': '{n} Mo',
  'studio.hooks.remove': 'Retirer {name}',
  'studio.hooks.state.ready': 'À envoyer',
  'studio.hooks.state.sending': 'Envoi…',
  'studio.hooks.state.sent': 'Envoyé',
  'studio.hooks.notVideo': 'Refusé : pas une vidéo mp4, mov ou webm',
  'studio.hooks.tooBig': 'Refusé : plus de 60 Mo',
  'studio.hooks.empty': 'Refusé : fichier vide',
  'studio.hooks.send': { one: 'Envoyer {n} hook', other: 'Envoyer {n} hooks' },
  'studio.hooks.sendNone': 'Envoyer les hooks',
  'studio.hooks.retry': 'Réessayer',
  'studio.hooks.done': { one: '{n} hook ajouté.', other: '{n} hooks ajoutés.' },
  'studio.hooks.failed': { one: '1 hook n’a pas été envoyé : réessayez ou retirez-le de la liste.', other: '{n} hooks n’ont pas été envoyés : réessayez ou retirez-les de la liste.' },
  'studio.hooks.notSent': { one: '1 hook n’a pas été envoyé (fenêtre fermée).', other: '{n} hooks n’ont pas été envoyés (fenêtre fermée).' },

  // A brief (its pub's page, the cards of « Nos pubs », its sheet without pub)
  'studio.brief.makePub': 'Créer la pub',
  'studio.brief.pubDone': 'Pub créée.',
  'studio.brief.phaseTitle': 'Où en est le script de cette pub',
  'studio.brief.phase.new': 'Script à écrire',
  'studio.brief.phase.writing': 'Script en écriture',
  'studio.brief.phase.validation': 'Script à valider',
  'studio.brief.phase.rework': 'Retouches demandées',
  'studio.brief.phase.error': 'Erreur sur le script',

  // Our ad, on one page (web/ui/studio-pub.js)
  'studio.pub.result': 'Notre pub',
  'studio.pub.noVideo': 'Pas encore de vidéo',
  'studio.pub.noVideoShort': 'Pas encore de vidéo',
  'studio.pub.why.production': 'En production : images et vidéos en cours. La pub sera montée quand toutes les séquences seront validées.',
  'studio.pub.why.draft': 'Toutes les séquences sont validées : en attente du montage.',
  'studio.pub.why.editing': 'Montage en cours.',
  'studio.pub.why.error': 'Le montage a échoué : voir l’historique de la pub.',
  'studio.pub.why.brief.new': 'Le script n’est pas encore écrit : le concepteur va s’en charger.',
  'studio.pub.why.brief.writing': 'Le script est en cours d’écriture.',
  'studio.pub.why.brief.validation': 'Le script attend ta validation : valide-le ou demande des retouches dans le brief.',
  'studio.pub.why.brief.rework': 'Retouches demandées au concepteur : le script est en cours de reprise.',
  'studio.pub.why.brief.error': 'Le script n’a pas pu être écrit : voir l’historique du brief.',
  'studio.pub.why.brief.other': 'Brief : {status}.',
  'studio.pub.p.scenes': 'Scènes avec image',
  'studio.pub.p.images': 'Images validées',
  'studio.pub.p.sequences': 'Séquences validées',
  'studio.pub.stops': { one: '1 élément attend une décision ou a une erreur', other: '{n} éléments attendent une décision ou ont une erreur' },
  'studio.pub.video.final': 'Sans texte',
  'studio.pub.video.sous-titres': 'Avec sous-titres',
  'studio.pub.video.musique': 'Avec musique',
  'studio.pub.video.other': 'Vidéo',
  'studio.pub.versionLabel': 'Version de la pub',
  'studio.pub.origin': 'Vient de',
  'studio.pub.originAd': 'Vient de · pub du concurrent',
  'studio.pub.originBrief': 'Vient de · script',
  'studio.pub.noOrigin': 'Créée sans pub concurrente ni script.',
  'studio.pub.brief': 'Brief',
  'studio.pub.brief.next.new': 'Le concepteur va écrire le script à partir de ton idée.',
  'studio.pub.brief.next.writing': 'Le concepteur écrit le script et découpe les scènes.',
  'studio.pub.brief.next.validation': 'Lis le script dans le brief, puis valide-le ou demande des retouches.',
  'studio.pub.brief.next.rework': 'Le concepteur reprend le script avec tes retours.',
  'studio.pub.brief.next.approved': 'Script validé : la production va démarrer.',
  'studio.pub.brief.next.ready': 'Script validé : la pub est en production.',
  'studio.pub.brief.next.error': 'Le script n’a pas pu être écrit : voir l’historique du brief.',
  'studio.pub.brief.feedback': 'Retouches demandées',
  'studio.pub.brief.approve': 'Valider le script',
  'studio.pub.brief.approved': 'Script validé.',
  'studio.pub.brief.rework': 'Demander des retouches',
  'studio.pub.brief.reworkTitle': 'Retouches du script',
  'studio.pub.brief.reworkLabel': 'Qu’est-ce qui doit changer dans le script ?',
  'studio.pub.brief.reworkHint': 'Le concepteur reprend le script avec ces retours.',
  'studio.pub.brief.reworkConfirm': 'Envoyer les retouches',
  'studio.pub.brief.reworkDone': 'Retouches envoyées au concepteur.',
  'studio.pub.brief.locked': 'Le concepteur travaille sur ce brief : tu pourras le modifier ensuite.',
  'studio.pub.brief.open': 'Voir le brief',
  'studio.pub.adLink': 'Voir la pub en ligne',
  'studio.pub.cut': 'Découpe du concurrent',
  'studio.pub.cutHint': 'Une capture par scène de la pub concurrente : cliquez pour l’agrandir ; l’icône paragraphe donne sa description.',
  'studio.pub.ours': 'Nos séquences',
  'studio.pub.inPub': 'Dans la pub',
  'studio.pub.outOfPub': 'Hors pub',
  'studio.pub.takeOut': 'Retirer cette séquence de la pub (elle reste dans le Studio pour d’autres pubs)',
  'studio.pub.putBack': 'Remettre cette séquence dans la pub',
  'studio.pub.outDone': 'Séquence retirée de la pub. Cliquez sur « Remonter la pub » pour refaire la vidéo.',
  'studio.pub.inDone': 'Séquence remise dans la pub. Cliquez sur « Remonter la pub » pour refaire la vidéo.',
  'studio.pub.seqSummary': '{done}/{total} validées',
  'studio.pub.oursHint': 'Scène par scène : notre image de départ, puis les vidéos faites à partir d’elle.',
  'studio.pub.ourImage': 'Notre image',
  'studio.pub.ourSequence': 'Notre vidéo',
  'studio.pub.noSequences': 'Séquences pas encore écrites',
  'studio.pub.gap.skipped': 'Scène écartée : pas dans la pub',
  'studio.pub.gap.error': 'Scène en erreur : pas dans la pub',
  'studio.pub.gap.forced': 'Création forcée : séquence en cours d’écriture',
  'studio.pub.gap.by': 'par {agent}',
  'studio.pub.gap.noReason': 'Aucune raison notée dans son historique.',
  'studio.pub.gap.badge': 'Écartée',
  'studio.pub.gap.forcedBadge': 'Création forcée',
  'studio.pub.gaps.title': { one: '1 scène n’a pas de séquence', other: '{n} scènes n’ont pas de séquence' },
  'studio.pub.gaps.made': { one: '1 scène manque dans la pub : elle n’a pas de séquence', other: '{n} scènes manquent dans la pub : elles n’ont pas de séquence' },
  'studio.pub.gaps.forced': 'Création forcée en cours : {titles}. La pub sera remontée avec dès que la vidéo sera validée.',
  'studio.pub.coming': 'Ajoutée une fois validée',
  'studio.pub.comingHint': 'Création forcée : cette séquence entrera dans la pub dès que sa vidéo sera validée, puis la pub sera remontée.',
  'studio.force.action': 'Forcer la création',
  'studio.force.tip': 'Faire écrire et tourner cette scène quand même, puis remonter la pub avec elle',
  'studio.force.title': 'Forcer la création · {title}',
  'studio.force.label': 'Consigne (facultatif)',
  'studio.force.hint': '{agent} écrira la séquence de cette scène cette fois, sans l’écarter : une pub en animation permet des images symboliques ; une phrase que la marque ne peut pas tenir sera reformulée. La vidéo sera ensuite générée et la pub remontée avec elle.',
  'studio.force.hintLead': 'Le chef du service fera écrire la séquence de cette scène, sans l’écarter : une pub en animation permet des images symboliques ; une phrase que la marque ne peut pas tenir sera reformulée. La vidéo sera ensuite générée et la pub remontée avec elle.',
  'studio.force.confirm': 'Forcer la création',
  'studio.force.done': 'Création forcée : la séquence va être écrite, puis la pub remontée avec elle.',
  'studio.pub.noScenes': 'Aucune scène pour l’instant : l’analyse ou le découpage n’a pas encore commencé.',
  'studio.pub.extra': 'Autres séquences de la pub',
  'studio.pub.missing.image': 'Image pas encore créée',
  'studio.pub.missing.video': 'Vidéo pas encore créée',
  'studio.pub.missing.error': 'Erreur',
  'studio.pub.details': 'Description',
  'studio.pub.history': 'Historique',
  'studio.pub.historyOf': 'Historique · {title}',
  'studio.pub.noHistory': 'Aucun historique.',
  'studio.pub.versions': 'Versions ({n})',
  'studio.pub.versionsOf': 'Toutes les versions · {title}',
  'studio.pub.latest': 'Dernière version',
  'studio.pub.older': 'Version {n}',
  'studio.pub.sheet': 'Ouvrir la fiche complète',
  'studio.pub.zoom': 'Agrandir {name}',
  'studio.pub.remake': 'Remonter la pub',
  'studio.pub.why.idea': 'Idée de remix : elle part au montage toute seule (tu ne valides que la pub finie).',
  'studio.pub.why.review': 'La pub est montée : à toi de la valider.',
  'studio.pub.open': 'Voir le détail',
  'studio.pub.openLabel': 'Voir le détail de {title}',
  'studio.pub.backTo': 'Retour à {title}',
  'studio.pub.path': 'Chemin : la pub, puis l’élément',
  'studio.pub.reserve': 'Avec réserve',
  'studio.pub.reserveHint': 'Le contrôle l’a refusée au dernier essai ; gardée pour finir la pub. Tu peux choisir une autre version ou la refuser.',
  'studio.pub.decide': 'La pub est prête : regarde-la et décide.',
  'studio.pub.decideNoVideo': 'La pub attend ta décision.',
  'studio.pub.approve': 'Valider la pub',
  'studio.pub.approved': 'Pub validée.',
  'studio.pub.changes': 'Demander des changements',
  'studio.pub.refuse': 'Refuser la pub',
  'studio.pub.refuseTitle': 'Refuser « {title} » ?',
  'studio.pub.refuseMessage': 'La pub passe en « Refusée » : elle reste dans le Studio, mais ne sera ni publiée ni remontée.',
  'studio.pub.refused': 'Pub refusée.',
  'studio.watch.title': 'CONTRÔLE DE PRODUCTION',
  'studio.watch.followUp': 'Relance : {agent}, {when}',
  'studio.watch.director': 'Escaladée au directeur : {agent}, {when}',
  'studio.watch.qa': 'Contrôle qualité demandé à {agent}, {when}',
  'studio.watch.task': 'Voir la tâche',
  'studio.watch.exhausted': 'Les relances n’ont rien donné : il faut regarder (À régler).',
  'studio.watch.kick': 'Relancer maintenant',
  'studio.watch.kicked': 'Relance envoyée.',
  'studio.watch.nothing': 'Rien à relancer : la pub avance.',
  'studio.detail.redo': 'Refaire',
  'studio.detail.refuse': 'Refuser · monter la pub sans elle',
  'studio.take.title': 'Versions générées',
  'studio.take.hint': 'Chaque essai est gardé : choisis celui qui te plaît, la pub est remontée avec.',
  'studio.take.none': 'Pas encore de version.',
  'studio.take.n': 'Version {n}',
  'studio.take.inUse': 'Utilisée dans la pub',
  'studio.take.use': 'Utiliser cette version',
  'studio.take.used': 'Version choisie.',
  'studio.take.usedRemount': 'Version choisie : la pub va être remontée avec.',
  'studio.refuse.title': 'Refuser « {title} »',
  'studio.refuse.label': 'Pourquoi ? (facultatif)',
  'studio.refuse.hint': 'La pub est montée sans cette séquence (remontée si elle l’était déjà). La séquence reste dans le Studio.',
  'studio.refuse.confirm': 'Refuser et remonter',
  'studio.refuse.done': 'Séquence refusée : la pub va être montée sans elle.',
  'studio.pub.noInfo': 'Le script et la durée apparaîtront après le montage.',
  'studio.pub.deleteMessage': 'La pub est supprimée ; ses séquences, ses images et la pub concurrente restent dans le Studio.',

  // Element
  'studio.back': 'Retour à la liste',
  'studio.crumbsLabel': 'Parents de l’élément',
  'studio.status': 'Statut',
  'studio.statusChanged': 'Statut changé : {label}.',
  'studio.responsible': 'Agent responsable',
  'studio.noAgent': 'Responsable du service',
  'studio.external': 'Lien externe',
  'studio.fields': 'Informations',
  'studio.noFields': 'Aucune information pour l’instant.',
  'studio.showMore': 'Afficher tout ({n} caractères)',
  'studio.showLess': 'Réduire',
  'studio.files': 'Fichiers',
  'studio.noFiles': 'Aucun fichier joint.',
  'studio.download': 'Télécharger',
  'studio.edit': 'Modifier',
  'studio.edit.save': 'Enregistrer',
  'studio.edit.cancel': 'Annuler',
  'studio.edit.title': 'Titre',
  'studio.edit.titlePerson': 'Nom',
  'studio.edit.saved': 'Modifications enregistrées.',
  'studio.edit.readonly': 'Rempli par les agents (lecture seule)',
  'studio.edit.number': 'Nombre attendu : {label}.',
  'studio.files.add': 'Ajouter des fichiers',
  'studio.files.role': 'Rôle des fichiers',
  'studio.files.sending': 'Envoi {i}/{n}…',
  'studio.files.done': { one: 'Fichier ajouté.', other: '{n} fichiers ajoutés.' },
  'studio.files.failed': '{name} : {error}',
  'studio.files.tooBig': 'plus de 60 Mo : joignez-le par un lien',
  'studio.files.remove': 'Retirer {name}',
  'studio.files.remove.title': 'Retirer « {name} » ?',
  'studio.files.remove.message': 'Le fichier sera supprimé définitivement de cet élément.',
  'studio.files.remove.confirm': 'Retirer',
  'studio.files.removed': 'Fichier retiré.',
  'studio.role.none': 'Sans rôle',
  'studio.role.base': 'Photo de base',
  'studio.role.visage': 'Visage',
  'studio.role.porte': 'Produit porté',
  'studio.role.photo': 'Photo',
  'studio.role.final': 'Résultat (le nôtre)',
  'studio.role.reference': 'Référence (casting, produit)',
  'studio.role.source': 'Vidéo du concurrent',
  'studio.role.cle': 'Capture du concurrent',
  'studio.role.sous-titres': 'Avec sous-titres',
  'studio.role.prise': 'Autre version',
  'studio.role.logo': 'Logo',
  'studio.role.musique': 'Avec musique de fond',
  'studio.parents': 'Vient de',
  'studio.children': 'Éléments issus de celui-ci',
  'studio.noChildren': 'Aucun élément n’en découle encore.',
  'studio.history': 'Historique',
  'studio.tags': 'Étiquettes',
  'studio.otherDept': 'Service « {dept} »',
  'studio.view.detail': 'Fiche',
  'studio.view.tree': 'Arbre',
  'studio.viewLabel': 'Affichage',
  'studio.regen': 'Regénérer',
  'studio.regen.title': 'Regénérer « {title} »',
  'studio.regen.label': 'Qu’est-ce qui doit changer ?',
  'studio.regen.hint': 'Une tâche est confiée à {agent} avec cette consigne.',
  'studio.regen.hintLead': 'Une tâche est confiée au responsable du service avec cette consigne.',
  'studio.regen.confirm': 'Confier la tâche',
  'studio.regen.done': 'Tâche créée : l’agent va regénérer l’élément.',
  'studio.regen.open': 'Voir la tâche',
  'studio.delete': 'Supprimer',
  'studio.delete.title': 'Supprimer « {title} » ?',
  'studio.delete.message': 'L’élément et ses fichiers seront supprimés définitivement.',
  'studio.delete.children': { one: 'Son élément enfant est conservé (détaché).', other: 'Ses {n} éléments enfants sont conservés (détachés).' },
  'studio.deleted': 'Élément supprimé.',
  'studio.gone': 'Cet élément a été supprimé.',
  'studio.tree.missing': 'À faire',
  'studio.tree.empty': 'Rien ne découle encore de cet élément.',
  'studio.tree.legend': 'Pointillés : en attente',

  // History actions
  'studio.h.create': 'Créé',
  'studio.h.status': 'Statut : {from} → {to}',
  'studio.h.update': 'Modifié ({fields})',
  'studio.h.note': 'Note',
  'studio.h.lock': 'Pris en charge',
  'studio.h.unlock': 'Rendu à la file',
  'studio.h.attach': 'Fichiers ajoutés',
  'studio.h.detachFile': 'Fichier retiré',
  'studio.h.regenerate': 'Regénération demandée',
  'studio.h.force': 'Création forcée',
  'studio.h.detach': 'Parent supprimé',
  'studio.h.version': 'Version choisie',
  'studio.h.title': 'Titre : « {from} » → « {to} »',
  'studio.h.by': 'par {who}',
});
